const TagDescription = {
    title: 'ROLES_DESCRIPTION',
    key: [],
    sections: [
        {
            columns: 1,
            fields: [
                {
                    label: 'CUSTOMER_TAGS_TAG_NAME',
                    key: ['name'],
                    isRequired: true,
                    pos: {
                        col: 1,
                        row: 1,
                        size: 1,
                    },
                },
            ],
        },
    ],
}

export { TagDescription }
